import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Sparkles, TrendingUp, Cpu } from 'lucide-react';

const AIMLSection = () => {
  const aimlAreas = [
    {
      icon: <Brain size={32} />,
      title: 'Machine Learning',
      description: 'Studying supervised and unsupervised learning algorithms',
      color: '#8b5cf6',
    },
    {
      icon: <Sparkles size={32} />,
      title: 'Deep Learning',
      description: 'Exploring neural networks and deep learning frameworks',
      color: '#ec4899',
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Data Analysis',
      description: 'Learning data preprocessing and feature engineering',
      color: '#f59e0b',
    },
    {
      icon: <Cpu size={32} />,
      title: 'AI Integration',
      description: 'Combining AI/ML with backend systems for intelligent apps',
      color: '#10b981',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section id="aiml" className="aiml-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">AI/ML Learning Journey</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Exploring Artificial Intelligence and Machine Learning to build intelligent systems
          </p>
        </motion.div>

        <motion.div
          className="aiml-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {aimlAreas.map((area, index) => (
            <motion.div
              key={index}
              className="aiml-card"
              variants={itemVariants}
              whileHover={{ y: -8, transition: { duration: 0.3 } }}
            >
              <div
                className="aiml-icon"
                style={{
                  backgroundColor: `${area.color}20`,
                  color: area.color,
                }}
              >
                {area.icon}
              </div>
              <h3 className="aiml-title">{area.title}</h3>
              <p className="aiml-description">{area.description}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="aiml-tools"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h3 className="aiml-tools-title">Learning & Tools</h3>
          <div className="aiml-tools-list">
            {['Python', 'TensorFlow', 'PyTorch', 'Scikit-learn', 'Pandas', 'NumPy', 'Keras', 'Jupyter'].map(
              (tool, index) => (
                <motion.span
                  key={index}
                  className="aiml-tool-tag"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.2 }}
                >
                  {tool}
                </motion.span>
              )
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AIMLSection;
